import React from 'react';
import {
  COMPANY_DOCUMENTS,
  COMPANY_DOCUMENT_MAP,
} from '../../../constants/companyDocuments';
import { COMPANY_DOCUMENT_STATUS } from '../../../services/companyDocuments';

export default function CompaniesTab({
  view,
  onShowList,
  onShowCreate,
  formTab,
  onChangeFormTab,
  isEditingCompany,
  headings,
  companyForm,
  companyError,
  documentsError,
  loadingCompanies,
  loadingDocuments,
  companies,
  companyDocuments,
  userOptions,
  onCompanyChange,
  onSubmitCompany,
  onResetCompanyForm,
  onEditCompany,
  onDeleteCompany,
  documentForm,
  onDocumentChange,
  onSubmitDocument,
  onResetDocumentForm,
  documentFormKey,
  onDeleteDocument,
  onUpdateDocumentStatus,
  formatLimitValue,
  resolveOwnerName,
  renderCategories,
  resolveDocumentUrl,
}) {
  return (
    <section className="admin-panel">
      <div className="admin-panel-card wide">
        <div className="admin-panel-tabs">
          <button
            type="button"
            className={`admin-panel-tab ${view === 'list' ? 'active' : ''}`}
            onClick={onShowList}
          >
            Ver empresas
          </button>
          <button
            type="button"
            className={`admin-panel-tab ${view === 'create' ? 'active' : ''}`}
            onClick={onShowCreate}
          >
            Crear empresa
          </button>
        </div>

        {view === 'list' ? (
          <CompanyListView
            companyError={companyError}
            loadingCompanies={loadingCompanies}
            companies={companies}
            formatLimitValue={formatLimitValue}
            renderCategories={renderCategories}
            resolveOwnerName={resolveOwnerName}
            onEditCompany={onEditCompany}
            onDeleteCompany={onDeleteCompany}
          />
        ) : (
          <CompanyCreateContent
            formTab={formTab}
            onChangeFormTab={onChangeFormTab}
            isEditingCompany={isEditingCompany}
            headings={headings}
            companyForm={companyForm}
            companyError={companyError}
            documentsError={documentsError}
            loadingCompanies={loadingCompanies}
            loadingDocuments={loadingDocuments}
            userOptions={userOptions}
            onCompanyChange={onCompanyChange}
            onSubmitCompany={onSubmitCompany}
            onResetCompanyForm={onResetCompanyForm}
            documentForm={documentForm}
            onDocumentChange={onDocumentChange}
          onSubmitDocument={onSubmitDocument}
          onResetDocumentForm={onResetDocumentForm}
          documentFormKey={documentFormKey}
          onDeleteDocument={onDeleteDocument}
          onUpdateDocumentStatus={onUpdateDocumentStatus}
          companyDocuments={companyDocuments}
          resolveDocumentUrl={resolveDocumentUrl}
        />
        )}
      </div>
    </section>
  );
}

function CompanyListView({
  companyError,
  loadingCompanies,
  companies,
  formatLimitValue,
  renderCategories,
  resolveOwnerName,
  onEditCompany,
  onDeleteCompany,
}) {
  return (
    <>
      {companyError && <div className="admin-alert error">{companyError}</div>}

      {loadingCompanies ? (
        <p>Cargando empresas...</p>
      ) : companies.length === 0 ? (
        <p>No hay empresas registradas.</p>
      ) : (
        <div className="admin-scroll full">
          <table className="admin-table">
            <thead>
              <tr>
                <th>Nombre</th>
                <th>Categorias</th>
                <th>Estatus</th>
                <th>Publicaciones</th>
                <th>Usuarios</th>
                <th>Owner</th>
                <th>Acciones</th>
              </tr>
            </thead>
            <tbody>
              {companies.map(company => (
                <tr key={company.id}>
                  <td>{company.name}</td>
                  <td>{renderCategories(company.category)}</td>
                  <td>
                    <span className={`badge badge-${company.status}`}>
                      {company.status === 'published' ? 'Publicado' : 'Borrador'}
                    </span>
                  </td>
                  <td>{formatLimitValue(company.publicationLimit)}</td>
                  <td>{formatLimitValue(company.userLimit)}</td>
                  <td>{resolveOwnerName(company.owner)}</td>
                  <td>
                    <div className="admin-table-actions">
                      <button
                        type="button"
                        className="admin-table-action"
                        onClick={() => onEditCompany(company)}
                        disabled={loadingCompanies}
                      >
                        Ver
                      </button>
                      <button
                        type="button"
                        className="admin-table-action delete"
                        onClick={() => onDeleteCompany(company)}
                        disabled={loadingCompanies}
                      >
                        Eliminar
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </>
  );
}

function CompanyCreateContent({
  formTab,
  onChangeFormTab,
  isEditingCompany,
  headings,
  companyForm,
  companyError,
  documentsError,
  loadingCompanies,
  loadingDocuments,
  userOptions,
  onCompanyChange,
  onSubmitCompany,
  onResetCompanyForm,
  documentForm,
  onDocumentChange,
  onSubmitDocument,
  onResetDocumentForm,
  documentFormKey,
  onDeleteDocument,
  onUpdateDocumentStatus,
  companyDocuments,
  resolveDocumentUrl,
}) {
  return (
    <>
      <div className="admin-panel-head">
        <div>
          <h2>{headings.title}</h2>
          <p>{headings.subtitle}</p>
        </div>
      </div>

      <CompanyFormTabs
        activeTab={formTab}
        onChange={onChangeFormTab}
        isEditingCompany={isEditingCompany}
      />

      {formTab === 'details' && (
        <CompanyDetailsForm
          companyError={companyError}
          companyForm={companyForm}
          onCompanyChange={onCompanyChange}
          onSubmitCompany={onSubmitCompany}
          onResetCompanyForm={onResetCompanyForm}
          loadingCompanies={loadingCompanies}
          isEditingCompany={isEditingCompany}
        />
      )}

      {formTab === 'settings' && (
        <CompanySettingsForm
          companyError={companyError}
          companyForm={companyForm}
          userOptions={userOptions}
          onCompanyChange={onCompanyChange}
          onSubmitCompany={onSubmitCompany}
          onResetCompanyForm={onResetCompanyForm}
          loadingCompanies={loadingCompanies}
          isEditingCompany={isEditingCompany}
        />
      )}

      {formTab === 'documents' && (
        <CompanyDocumentsSection
          documentsError={documentsError}
          isEditingCompany={isEditingCompany}
          documentForm={documentForm}
          onDocumentChange={onDocumentChange}
          onSubmitDocument={onSubmitDocument}
          onResetDocumentForm={onResetDocumentForm}
          loadingDocuments={loadingDocuments}
          documentFormKey={documentFormKey}
          companyDocuments={companyDocuments}
          resolveDocumentUrl={resolveDocumentUrl}
          onDeleteDocument={onDeleteDocument}
          onUpdateDocumentStatus={onUpdateDocumentStatus}
        />
      )}

    </>
  );
}

function CompanyFormTabs({ activeTab, onChange, isEditingCompany }) {
  return (
    <div className="admin-subtabs">
      <button
        type="button"
        className={`admin-subtab ${activeTab === 'details' ? 'active' : ''}`}
        onClick={() => onChange('details')}
      >
        Datos generales
      </button>
      <button
        type="button"
        className={`admin-subtab ${activeTab === 'settings' ? 'active' : ''}`}
        onClick={() => onChange('settings')}
      >
        Configuracion
      </button>
      <button
        type="button"
        className={`admin-subtab ${activeTab === 'documents' ? 'active' : ''}`}
        onClick={() => onChange('documents')}
        disabled={!isEditingCompany}
        title={
          isEditingCompany
            ? 'Gestiona los documentos de esta empresa'
            : 'Guarda la empresa para habilitar esta seccion'
        }
      >
        Documentos
      </button>
    </div>
  );
}

function CompanyDetailsForm({
  companyError,
  companyForm,
  onCompanyChange,
  onSubmitCompany,
  onResetCompanyForm,
  loadingCompanies,
  isEditingCompany,
}) {
  return (
    <>
      {companyError && <div className="admin-alert error">{companyError}</div>}

      <form className="admin-structured-form" onSubmit={onSubmitCompany}>
        <div className="admin-form-columns">
          <section className="admin-form-section">
            <header>
              <h3>Identidad</h3>
              <p>Define como se presenta la empresa dentro del marketplace.</p>
            </header>
            <div className="admin-section-grid three">
              <label>
                Nombre
                <input
                  type="text"
                  value={companyForm.name}
                  onChange={e => onCompanyChange('name', e.target.value)}
                  required
                />
              </label>

              <input type="hidden" value={companyForm.slug} readOnly />

              <label className="admin-multiselect">
                Categorias
                <select
                  multiple
                  className="admin-select"
                  value={companyForm.categories}
                  onChange={e =>
                    onCompanyChange(
                      'categories',
                      Array.from(e.target.selectedOptions, option => option.value)
                    )
                  }
                >
                  <option value="ground_transport">Servicios terrestres</option>
                  <option value="security_service">Custodia y seguridad</option>
                  <option value="suppliers">Proveedores</option>
                  <option value="logistics_operator">Operador logistico</option>
                  <option value="road_assistance">Asistencia vial</option>
                  <option value="client">Cliente</option>
                </select>
                <span className="admin-helper-text">
                  Presiona Ctrl/Cmd para seleccionar varias categorias.
                </span>
              </label>
            </div>
          </section>

          <section className="admin-form-section">
            <header>
              <h3>Ubicacion</h3>
              <p>La direccion ayuda a coordinar visitas, logistica y verificaciones.</p>
            </header>
            <div className="admin-section-grid three">
              <label>
                Calle
                <input
                  type="text"
                  value={companyForm.street}
                  onChange={e => onCompanyChange('street', e.target.value)}
                  placeholder="Ej. Av. Reforma"
                />
              </label>
              <label>
                Numero
                <input
                  type="text"
                  value={companyForm.streetNumber}
                  onChange={e => onCompanyChange('streetNumber', e.target.value)}
                  placeholder="Ej. 101B"
                />
              </label>
              <label>
                Ciudad
                <input
                  type="text"
                  value={companyForm.city}
                  onChange={e => onCompanyChange('city', e.target.value)}
                />
              </label>
            </div>
            <div className="admin-section-grid three">
              <label>
                Estado / Provincia
                <input
                  type="text"
                  value={companyForm.state}
                  onChange={e => onCompanyChange('state', e.target.value)}
                />
              </label>
              <label>
                Pais
                <input
                  type="text"
                  value={companyForm.country}
                  onChange={e => onCompanyChange('country', e.target.value)}
                />
              </label>
              <label>
                Codigo postal
                <input
                  type="text"
                  value={companyForm.postalCode}
                  onChange={e => onCompanyChange('postalCode', e.target.value)}
                />
              </label>
            </div>
          </section>
        </div>

        <CompanyFormActions
          loadingCompanies={loadingCompanies}
          isEditingCompany={isEditingCompany}
          onResetCompanyForm={onResetCompanyForm}
        />
      </form>
    </>
  );
}

function CompanySettingsForm({
  companyError,
  companyForm,
  userOptions,
  onCompanyChange,
  onSubmitCompany,
  onResetCompanyForm,
  loadingCompanies,
  isEditingCompany,
}) {
  return (
    <>
      {companyError && <div className="admin-alert error">{companyError}</div>}

      <form className="admin-structured-form" onSubmit={onSubmitCompany}>
        <section className="admin-form-section">
          <header>
            <h3>Configuracion</h3>
            <p>Controla permisos, limites y asignaciones para esta empresa.</p>
          </header>
          <div className="admin-section-grid three">
            <label>
              Estatus
              <select
                className="admin-select"
                value={companyForm.status}
                onChange={e => onCompanyChange('status', e.target.value)}
              >
                <option value="draft">Borrador</option>
                <option value="published">Publicado</option>
              </select>
            </label>

            <label>
              Owner (opcional)
              <select
                className="admin-select"
                value={companyForm.owner}
                onChange={e => onCompanyChange('owner', e.target.value)}
              >
                <option value="">Selecciona un usuario</option>
                {userOptions.map(option => (
                  <option key={option.id} value={option.id}>
                    {option.label}
                  </option>
                ))}
              </select>
            </label>

            <label>
              Limite de publicaciones
              <input
                type="number"
                min="0"
                step="1"
                value={companyForm.publicationLimit}
                onChange={e => onCompanyChange('publicationLimit', e.target.value)}
              />
            </label>

            <label>
              Limite de usuarios
              <input
                type="number"
                min="0"
                step="1"
                value={companyForm.userLimit}
                onChange={e => onCompanyChange('userLimit', e.target.value)}
              />
            </label>
          </div>

          <div className="admin-switches">
            <label className="toggle">
              <input
                type="checkbox"
                checked={companyForm.canPublish}
                onChange={e => onCompanyChange('canPublish', e.target.checked)}
              />
              <span>Puede publicar listings</span>
            </label>
            <label className="toggle">
              <input
                type="checkbox"
                checked={companyForm.isVerified}
                onChange={e => onCompanyChange('isVerified', e.target.checked)}
              />
              <span>Empresa verificada</span>
            </label>
          </div>
        </section>

        <CompanyFormActions
          loadingCompanies={loadingCompanies}
          isEditingCompany={isEditingCompany}
          onResetCompanyForm={onResetCompanyForm}
        />
      </form>
    </>
  );
}

function CompanyDocumentsSection({
  documentsError,
  isEditingCompany,
  documentForm,
  onDocumentChange,
  onSubmitDocument,
  onResetDocumentForm,
  loadingDocuments,
  documentFormKey,
  companyDocuments,
  resolveDocumentUrl,
  onDeleteDocument,
  onUpdateDocumentStatus,
}) {
  if (!isEditingCompany) {
    return (
      <>
        {documentsError && <div className="admin-alert error">{documentsError}</div>}
        <p className="admin-helper-text">Guarda la empresa antes de adjuntar documentos.</p>
      </>
    );
  }

  const resolveStatusLabel = status => {
    switch (status) {
      case COMPANY_DOCUMENT_STATUS.VERIFIED:
        return 'Verificado';
      case COMPANY_DOCUMENT_STATUS.REJECTED:
        return 'Rechazado';
      case COMPANY_DOCUMENT_STATUS.PENDING:
      default:
        return 'En revision';
    }
  };

  const handleStatusChange = (document, status) => {
    if (typeof onUpdateDocumentStatus === 'function') {
      onUpdateDocumentStatus(document, status);
    }
  };

  const renderStatusBadge = status => {
    const effective = status || COMPANY_DOCUMENT_STATUS.PENDING;
    const label = resolveStatusLabel(effective);
    const className = `admin-status-badge status-${effective}`;
    return <span className={className}>{label}</span>;
  };

  return (
    <>
      {documentsError && <div className="admin-alert error">{documentsError}</div>}

      <form className="admin-grid-form" onSubmit={onSubmitDocument}>
        <label>
          Tipo de documento
          <select
            value={documentForm.documentKey}
            onChange={e => onDocumentChange('documentKey', e.target.value)}
            required
          >
            <option value="">Selecciona una opcion</option>
            {COMPANY_DOCUMENTS.map(option => (
              <option key={option.key} value={option.key}>
                {option.label}
              </option>
            ))}
          </select>
        </label>

        <label>
          Titulo
          <input
            type="text"
            value={documentForm.title}
            onChange={e => onDocumentChange('title', e.target.value)}
            required
          />
        </label>

        <label>
          Archivo
          <input
            type="file"
            key={documentFormKey}
            onChange={e =>
              onDocumentChange(
                'file',
                e.target.files && e.target.files.length > 0 ? e.target.files[0] : null
              )
            }
            required
          />
        </label>

        <label className="stretch">
          Notas (opcional)
          <textarea
            rows={3}
            value={documentForm.notes}
            onChange={e => onDocumentChange('notes', e.target.value)}
            placeholder="Agrega contexto o instrucciones sobre el documento"
          />
        </label>

        <div className="admin-form-actions">
          <button type="submit" disabled={loadingDocuments}>
            {loadingDocuments ? 'Subiendo...' : 'Subir documento'}
          </button>
          <button type="button" className="link" onClick={onResetDocumentForm}>
            Limpiar formulario
          </button>
        </div>
      </form>

      {loadingDocuments ? (
        <p>Cargando documentos...</p>
      ) : companyDocuments.length === 0 ? (
        <p className="admin-helper-text">Aun no se han cargado documentos para esta empresa.</p>
      ) : (
        <div className="admin-scroll">
          <table className="admin-table compact">
            <thead>
              <tr>
                <th>Documento</th>
                <th>Estatus</th>
                <th>Archivo</th>
                <th>Actualizado</th>
                <th>Acciones</th>
              </tr>
            </thead>
            <tbody>
              {companyDocuments.map(document => {
                const definition = COMPANY_DOCUMENT_MAP[document.documentKey];
                const docLabel = definition?.label || document.title || 'Sin titulo';
                const status = document.status || COMPANY_DOCUMENT_STATUS.PENDING;
                const fileUrl = resolveDocumentUrl(document);
                const updatedAt = document.reviewedAt
                  ? new Date(document.reviewedAt).toLocaleString()
                  : document.updated
                  ? new Date(document.updated).toLocaleString()
                  : '-';
                const notes = document.notes?.trim();

                return (
                  <tr key={document.id}>
                    <td>
                      <div className="admin-doc-title">{docLabel}</div>
                      {definition?.category && (
                        <div className="admin-doc-subtitle">{definition.category}</div>
                      )}
                      {notes && <div className="admin-doc-notes">{notes}</div>}
                    </td>
                    <td>{renderStatusBadge(status)}</td>
                    <td>
                      {document.file ? (
                        <a href={fileUrl} target="_blank" rel="noopener noreferrer">
                          Ver archivo
                        </a>
                      ) : (
                        'Sin archivo'
                      )}
                    </td>
                    <td>{updatedAt}</td>
                    <td>
                      <div className="admin-table-actions">
                        {status !== COMPANY_DOCUMENT_STATUS.VERIFIED && (
                          <button
                            type="button"
                            className="admin-table-action"
                            onClick={() => handleStatusChange(document, COMPANY_DOCUMENT_STATUS.VERIFIED)}
                            disabled={loadingDocuments}
                          >
                            Verificar
                          </button>
                        )}
                        {status === COMPANY_DOCUMENT_STATUS.VERIFIED && (
                          <button
                            type="button"
                            className="admin-table-action"
                            onClick={() => handleStatusChange(document, COMPANY_DOCUMENT_STATUS.PENDING)}
                            disabled={loadingDocuments}
                          >
                            Marcar pendiente
                          </button>
                        )}
                        {status !== COMPANY_DOCUMENT_STATUS.REJECTED && (
                          <button
                            type="button"
                            className="admin-table-action warn"
                            onClick={() => handleStatusChange(document, COMPANY_DOCUMENT_STATUS.REJECTED)}
                            disabled={loadingDocuments}
                          >
                            Rechazar
                          </button>
                        )}
                        <button
                          type="button"
                          className="admin-table-action delete"
                          onClick={() => onDeleteDocument(document)}
                          disabled={loadingDocuments}
                        >
                          Eliminar
                        </button>
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </>
  );
}



function CompanyFormActions({ loadingCompanies, isEditingCompany, onResetCompanyForm }) {
  return (
    <div className="admin-form-actions">
      <button type="submit" disabled={loadingCompanies}>
        {loadingCompanies
          ? 'Guardando...'
          : isEditingCompany
          ? 'Actualizar empresa'
          : 'Crear empresa'}
      </button>
      <button type="button" className="link" onClick={onResetCompanyForm}>
        {isEditingCompany ? 'Cancelar edicion' : 'Limpiar formulario'}
      </button>
    </div>
  );
}
